import React from 'react';
import CharacterStockIcon from 'react/chat/inner/display_pieces/messages/CharacterStockIcon';
import TextWithElements from 'react/elements/TextWithElements';
import useCompactChatStyle from 'react/chat/inner/display_pieces/messages/kinds/useCompactChatStyle';
import { __ } from 'i18n/index';
import { MODE_NAMES } from 'react/chat/inner/display_pieces/messages/kinds/modeNames';
import { formatLadderTime } from 'react/elements/LadderTime';

// A side's icons: one per player (both players of a doubles team), or the
// side's own main.
function sideMains(side) {
	if(Array.isArray(side.players) && side.players.length) {
		return side.players.map((player) => player.main || null);
	}
	return [side.main || null];
}

function Side({ side, kind }) {
	return (
		<span className={`chat-result-card__side chat-result-card__side--${kind}`} data-testid={`result-${kind}`}>
			<span className='chat-result-card__icons'>
				{/* Teammates can play the same character, so key by position. */}
				{sideMains(side).map((character, index) => (
					<CharacterStockIcon key={index} character={character} />
				))}
			</span>
			{side.username}
		</span>
	);
}

// A posted set result (message kind 'match_result'), drawn as one line:
// mode tag, "<winner> beat <loser> 2–1", time. It is a system message: no
// sender row, reactions or toolbar.
export default function MatchResultCard({ message }) {
	const compact = useCompactChatStyle();
	const result = message.getMatchResult();
	if(!result || !result.winner || !result.loser) {
		return null;
	}
	const mode = MODE_NAMES[result.mode] ? result.mode : 'friendlies';
	const time = message.time ? formatLadderTime(message.time, 'clock') : '';
	const classes = ['chat_message', 'chat-result-card', `chat-result-card--${mode}`];
	if(compact) {
		classes.push('chat-result-card--compact');
	}
	return (
		<div className={classes.join(' ')} data-id={message.id} data-testid='result-card'>
			<span className='chat-result-card__mode'>{MODE_NAMES[mode]}</span>
			<span className='chat-result-card__text'>
				<TextWithElements
					text={__('%1$s beat %2$s')}
					elements={[<Side key='winner' side={result.winner} kind='winner' />, <Side key='loser' side={result.loser} kind='loser' />]}
				/>
				{' '}
				<span className='chat-result-card__score'>{`${result.winner.score}–${result.loser.score}`}</span>
			</span>
			{time && <span className='chat-result-card__time'>{time}</span>}
		</div>
	);
}
